import { types } from 'mobx-state-tree';
import { RequestStateModel } from '../../general-models';

export const RequestsModel = types.model({
  getChats: types.optional(RequestStateModel, {}),
  loadMoreChats: types.optional(RequestStateModel, {}),
  searchMessages: types.optional(RequestStateModel, {}),
  loadMoreSearchMessages: types.optional(RequestStateModel, {}),
});
